const blockerType = {
  GLOBAL: 1,
  ON_DEMAND: 2,
  LOCAL: 3,
} as const

export type BlockerType = typeof blockerType[keyof typeof blockerType]

export default blockerType